import { Wifi, Car, Wind, Home, Utensils, Sun, Waves, TreePine } from 'lucide-react';

export const studiosData = {
  name: 'Damaskis Kassiopi Studios',
  tagline: 'Your Perfect Greek Escape in Beautiful Kassiopi',
  location: 'Kassiopi, 49100, Greece',
  address: 'Kassiopi, Kassiopi',
  rating: '9.2',
  reviewCount: 150,
  locationRating: '9.3',
  email: 'mail@kassiopistudios.com',
  phone: '+30 123 456 7890',
  whatsapp: '+306947817929',
  facebook: 'https://www.facebook.com/damaskisstudios',
  bookingUrl: 'https://beds24.com/booking.php?propid=133929&referer=damaskis',
  description: 'Offering a garden, Damaskis Kassiopi Studios provides comfortable accommodations in the heart of Kassiopi. This charming property features a sun terrace, peaceful garden, and modern amenities including free WiFi, air conditioning, and private parking. Each studio includes a kitchenette, private bathroom, and balcony or patio with garden views. Located just a 5-minute walk from Kalamionas Beach, our studios are perfectly positioned to explore the beautiful Corfu coastline.',
  
  images: [
    'https://cf.bstatic.com/xdata/images/hotel/max1024x768/432044419.jpg?k=344e49f606b895d7a5652a90132f9a7a78ba1b38ed34eaca1775c5ff490b29d3&o=',
    'https://cf.bstatic.com/xdata/images/hotel/max500/432044417.jpg?k=1044dd315851ddbe784072b30aa8e47f1410101eeca04aa7735097fe39c91607&o=',
    'https://cf.bstatic.com/xdata/images/hotel/max500/432044436.jpg?k=d3c96295ad71ff9ff213de665489c15198127da98eb13b18f364e5b28ceb8a08&o=',
    'https://cf.bstatic.com/xdata/images/hotel/max300/432044439.jpg?k=1085807653071b506d7f3de0ab723c33cf714a50d5dda780e0c9370de8657573&o=',
    'https://cf.bstatic.com/xdata/images/hotel/max300/432044446.jpg?k=1d33571e57a562476f1256b0663494921693759b5e85a759e9c601ee91c51ef6&o=',
    'https://cf.bstatic.com/xdata/images/hotel/max300/432044447.jpg?k=7f537fd4679e1ae841853016b73cbabac0337604f9df3a4bc6606ad91c8e4461&o=',
    'https://cf.bstatic.com/xdata/images/hotel/max300/18880882.jpg?k=da949ca32b56dc10a96a5d994d1769b2512206cdb24dc2afa7c9b36901781a12&o=',
    'https://cf.bstatic.com/xdata/images/hotel/max300/432044414.jpg?k=5f64f152a5d8121b5519c820a97071537938c8e3f2095557fccb6a5a8a6d669b&o='
  ],
  
  amenities: [
    {
      icon: Wifi,
      title: 'Free WiFi',
      description: 'High-speed internet throughout the property (10/10 rating)'
    },
    {
      icon: Car,
      title: 'Free Parking',
      description: 'Private on-site parking available at no extra charge'
    },
    {
      icon: Wind,
      title: 'Air Conditioning',
      description: 'All rooms feature modern air conditioning systems'
    },
    {
      icon: Home,
      title: 'Private Studios',
      description: '269 ft² self-contained studios with kitchenette'
    },
    {
      icon: Utensils,
      title: 'Kitchenette',
      description: 'Equipped with tea/coffee maker and cooking facilities'
    },
    {
      icon: Sun,
      title: 'Balcony/Terrace',
      description: 'Private outdoor space with garden views'
    },
    {
      icon: TreePine,
      title: 'Garden Access',
      description: 'Beautiful garden and sun terrace for relaxation'
    },
    {
      icon: Waves,
      title: 'Beach Nearby',
      description: 'Just 5 minutes walk to Kalamionas Beach (8.8/10 rating)'
    }
  ],
  
  reviews: [
    {
      name: 'Mandy',
      country: 'United Kingdom',
      comment: 'Bathroom excellent, very comfy beds, friendly host, excellent position. Very good place to stay.'
    },
    {
      name: 'Ross',
      country: 'United Kingdom',
      comment: 'The bed was very comfy. Lots of places to put clothes and many hangers. The air con, fan, and curtains all worked well. The back garden was great. The location was fantastic.'
    },
    {
      name: 'Mark',
      country: 'United Kingdom',
      comment: 'Fabulous location, close to all amenities. The room and bathroom were clean and well equipped.'
    },
    {
      name: 'Sufiella',
      country: 'Poland',
      comment: 'A very cozy hotel with good parking and friendly, helpful staff. The highlight was the incredibly charming balcony under an olive tree, which created a unique atmosphere.'
    },
    {
      name: 'Kapodistria',
      country: 'Greece',
      comment: 'The location was perfect, there was car parking. It was very clean and comfortable. The bathroom was recently renovated with style. The staff was very friendly and kind.'
    },
    {
      name: 'Stephanie',
      country: 'United Kingdom',
      comment: 'Excellent all round. The owner went above and beyond sorting out a taxi and making me a coffee. Room was delightful and perfectly equipped. The outside space was comfortable.'
    }
  ]
};